module.exports = __webpack_public_path__ + "img/description3.507daff9.jpg";